export var FormSource;
(function (FormSource) {
    FormSource["Divorce"] = "divorce";
    FormSource["Ai"] = "ai";
})(FormSource || (FormSource = {}));
export var FormAnswerType;
(function (FormAnswerType) {
    FormAnswerType["FreeText"] = "free-text";
    FormAnswerType["YesNo"] = "yes-no";
    FormAnswerType["MultipleChoice"] = "multiple-choice";
    FormAnswerType["Numeric"] = "numeric";
    FormAnswerType["Date"] = "date";
    FormAnswerType["Time"] = "time";
    FormAnswerType["DateTime"] = "datetime";
})(FormAnswerType || (FormAnswerType = {}));
export var QuestionType;
(function (QuestionType) {
    QuestionType["Text"] = "text";
    QuestionType["FreeText"] = "free-text";
    QuestionType["YesNo"] = "yes-no";
    QuestionType["Numeric"] = "numeric";
    QuestionType["Financial"] = "financial";
    QuestionType["Date"] = "date";
    QuestionType["Time"] = "time";
    QuestionType["SplitDate"] = "split-date";
    QuestionType["DateTime"] = "datetime";
    QuestionType["Radio"] = "radio";
    QuestionType["Checkbox"] = "checkbox";
    QuestionType["MultiPart"] = "multi-part";
    QuestionType["Scale"] = "scale";
    QuestionType["Items"] = "items";
    QuestionType["File"] = "file";
    QuestionType["Email"] = "email";
    QuestionType["Phone"] = "phone";
    QuestionType["Select"] = "select";
    QuestionType["Dropdown"] = "dropdown";
})(QuestionType || (QuestionType = {}));
export var ClientIntakeFormType;
(function (ClientIntakeFormType) {
    ClientIntakeFormType["Generic"] = "generic";
    ClientIntakeFormType["Divorce"] = "divorce";
    ClientIntakeFormType["AIGenerated"] = "ai-generated";
})(ClientIntakeFormType || (ClientIntakeFormType = {}));
export var IntroductoryFormType;
(function (IntroductoryFormType) {
    IntroductoryFormType["Divorce"] = "divorce";
    IntroductoryFormType["AIGenerated"] = "ai-generated";
})(IntroductoryFormType || (IntroductoryFormType = {}));
export var FormQuestionIds;
(function (FormQuestionIds) {
    FormQuestionIds["sendCaseToLawyer"] = "send-case-to-lawyer";
    FormQuestionIds["quoteForLawyer"] = "quote-for-lawyer";
    FormQuestionIds["phoneNumber"] = "phone-number";
    FormQuestionIds["lawyerIntroduction"] = "lawyer-introduction";
    FormQuestionIds["additionalFiles"] = "additional-files";
    FormQuestionIds["connectionIntent"] = "connection-intent";
    FormQuestionIds["financialCapability"] = "financial-capability";
    FormQuestionIds["informationType"] = "information-type";
    FormQuestionIds["decisionHelp"] = "decision-help";
    FormQuestionIds["urgencyLevel"] = "urgency-level";
    FormQuestionIds["experienceLevel"] = "experience-level";
})(FormQuestionIds || (FormQuestionIds = {}));
export var ContactLawyerQuestionOptions;
(function (ContactLawyerQuestionOptions) {
    ContactLawyerQuestionOptions["GetAQuoteNow"] = "get-a-quote-now";
    ContactLawyerQuestionOptions["MaybeLater"] = "maybe-later";
    ContactLawyerQuestionOptions["NotInterested"] = "not-interested";
})(ContactLawyerQuestionOptions || (ContactLawyerQuestionOptions = {}));
export var ConnectionIntentOptions;
(function (ConnectionIntentOptions) {
    ConnectionIntentOptions["ReadyToHire"] = "ready-to-hire";
    ConnectionIntentOptions["WantConsult"] = "want-consult";
    ConnectionIntentOptions["MaybeLater"] = "maybe-later";
    ConnectionIntentOptions["NotNow"] = "not-now";
})(ConnectionIntentOptions || (ConnectionIntentOptions = {}));
export var FinancialCapabilityOptions;
(function (FinancialCapabilityOptions) {
    FinancialCapabilityOptions["CanPay"] = "can-pay";
    FinancialCapabilityOptions["NeedAssistance"] = "need-assistance";
})(FinancialCapabilityOptions || (FinancialCapabilityOptions = {}));
export var InformationTypeOptions;
(function (InformationTypeOptions) {
    InformationTypeOptions["PricingInfo"] = "pricing-info";
    InformationTypeOptions["LegalAid"] = "legal-aid";
    InformationTypeOptions["ProcessInfo"] = "process-info";
    InformationTypeOptions["NeedAssessment"] = "need-assessment";
})(InformationTypeOptions || (InformationTypeOptions = {}));
export var DecisionHelpOptions;
(function (DecisionHelpOptions) {
    DecisionHelpOptions["LegalOptions"] = "legal-options";
    DecisionHelpOptions["SecondOpinion"] = "second-opinion";
    DecisionHelpOptions["PricingUnderstanding"] = "pricing-understanding";
})(DecisionHelpOptions || (DecisionHelpOptions = {}));
export var UrgencyLevelOptions;
(function (UrgencyLevelOptions) {
    UrgencyLevelOptions["Today"] = "today";
    UrgencyLevelOptions["WithinDays"] = "within-days";
    UrgencyLevelOptions["ThisWeek"] = "this-week";
    UrgencyLevelOptions["ComparingQuotes"] = "comparing-quotes";
})(UrgencyLevelOptions || (UrgencyLevelOptions = {}));
export var ExperienceLevelOptions;
(function (ExperienceLevelOptions) {
    ExperienceLevelOptions["CurrentLawyer"] = "current-lawyer";
    ExperienceLevelOptions["PreviousLawyer"] = "previous-lawyer";
    ExperienceLevelOptions["NeverWorked"] = "never-worked";
})(ExperienceLevelOptions || (ExperienceLevelOptions = {}));
export var LeadCategory;
(function (LeadCategory) {
    LeadCategory["Premium"] = "premium";
    LeadCategory["Information"] = "information";
    LeadCategory["Nurture"] = "nurture";
    LeadCategory["NoLead"] = "no-lead";
})(LeadCategory || (LeadCategory = {}));
export var UrgencyLevel;
(function (UrgencyLevel) {
    UrgencyLevel["VeryUrgent"] = "very-urgent";
    UrgencyLevel["Urgent"] = "urgent";
    UrgencyLevel["Medium"] = "medium";
    UrgencyLevel["Low"] = "low";
})(UrgencyLevel || (UrgencyLevel = {}));
;
//# sourceMappingURL=form.js.map